import {
    TudoRef,
    TudoAli,
    TudoBus,
    TudoCalendar,
    TudoHand,
    TudoHouse,
    TudoTicket
} from 'assets/img/product-details/tudo/benefits'

import {
    PodAliRef,
    PodApp,
    PodCoverage,
    PodDelivry,
    PodDigitalCard,
    PodProximity
} from 'assets/img/product-details/pod/benefits'

export const flexibleBenefits = [
    {
        icon: TudoAli,
        text: 'Alimentação'
    },
    {
        icon: TudoTicket,
        text: 'Cultura'
    },
    {
        icon: TudoRef,
        text: 'Refeição'
    },
    {
        icon: TudoHand,
        text: 'Saúde'
    },
    {
        icon: TudoHouse,
        text: 'Auxílio home office'
    },
    {
        icon: TudoCalendar,
        text: 'Antecipação salarial'
    },
    {
        icon: TudoBus,
        text: 'Ajuda de custo de mobilidade'
    }
]

export const flexibleBenefitsPOD = [
    {
        icon: PodDigitalCard,
        title: 'Cartão digital',
        text: 'pode usar para compras online',
        pos: 'right',
        deskIndex: 1
    },
    {
        icon: PodDelivry,
        title: 'Aceito no Delivery',
        text: 'pode pagar direto  nos aplicativos',
        pos: 'left',
        deskIndex: 0
    },
    {
        icon: PodAliRef,
        title: 'Alimentação + Refeição',
        text: 'pode usar para ambos os saldos, tudo em um só cartão',
        pos: 'left',
        deskIndex: 2
    },
    {
        icon: PodProximity,
        title: 'Aproximou, pagou!',
        text: 'pode pagar a conta com rapidez e segurança',
        pos: 'right',
        deskIndex: 3
    },
    {
        icon: PodCoverage,
        title: 'Aceito em todo o Brasil',
        text: 'pode usar na função crédito. O Alelo Pod tem bandeira Elo',
        pos: 'right',
        deskIndex: 5
    },
    {
        icon: PodApp,
        title: 'Aplicativo Exclusivo',
        text: 'pode acompanhar  o saldo direto no app',
        pos: 'left',
        deskIndex: 4
    }
]
